// Base
import { useEffect } from "react";

// Sections
import Checkout from "@/sections/Checkout";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";

// Store
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore";

// Utils
import getCookie from "@/func/getCookie";

export default function Layout() {
  const { isMobile } = useTemplateStore();
  const productData = useProductData();

  useEffect(() => {
    const encodedAffParam = new URL(location.href).searchParams.get("aff");
    const encodedAffSourceParam = new URL(location.href).searchParams.get(
      "affSource",
    );
    let decodedAffParam: string | null = null;
    let affiliateSourceTag: string | null = null;

    if (encodedAffParam) {
      try {
        decodedAffParam = atob(encodedAffParam);
      } catch (e) {
        decodedAffParam = null;
      }
    }

    if (encodedAffSourceParam) {
      try {
        affiliateSourceTag = atob(encodedAffSourceParam);
      } catch (e) {
        affiliateSourceTag = null;
      }
    }

    const affCookie = getCookie("affiliate_tag");
    const affiliateTag = decodedAffParam || affCookie || undefined;

    if (window.postId !== undefined) {
      productData.get({
        postId: window.postId,
        isMobile: isMobile,
        affParam: affiliateTag,
        affSourceParam: affiliateSourceTag,
      });
    }
  }, [isMobile]);

  return (
    <>
      <Header />
      <Checkout />
      <Footer />
    </>
  );
}
